import React from 'react'
import FooterLogic from '../../shared/_layouts/_templates/_includes/footer/footer-logic.jsx'
import Nav from '../../shared/_layouts/_templates/_includes/new-nav.jsx'
import Engine from 'core-booking-forms'
import HomePageBanner from '../../shared/_layouts/_templates/_includes/homepage/homePageBanner.jsx'
import Editorial from '../../shared/_layouts/_templates/_includes/homepage/Editorial.jsx'
import PromoModal from '../../shared/_layouts/_templates/_includes/modals/PromoModal.jsx'
import ReduxStores from '../../shared/stores/connects'
import Tracker from '../../_plugins/lib/tracker'
import Helpers from '../../_plugins/lib/helpers'
import classNames from 'classnames'
import { object } from 'prop-types'

class Homepage extends React.Component {
  constructor (props) {
    super(props)
    if (props.agentSetup) props.agentSetup()
    if (props.initialSetup) props.initialSetup()
  }

  componentWillReceiveProps (nextProps) {
    if (!this.props.agentData.agent && nextProps.agentData.agent) {
      this.initialLoad(nextProps)
    }
  }

  initialLoad (props) {
    const { agentData: { agent } } = props
    let environment = props.settings.env
    if (Helpers.getParameterByName('data-pipeline-staging')) environment = 'staging'
    if (Helpers.getParameterByName('data-pipeline-production')) environment = 'production'
    Tracker.init({
      agent,
      environment,
      templateGroup: 'homepage',
      schemaVersions: {
        cache_primer: 'v1.0.0',
        initialise: 'v1.1.0',
        auto_capture: 'v1.1.0',
        booking_made: 'v1.0.0',
        booking_viewed: 'v1.0.0',
        capture: 'v1.0.0',
        click: 'v1.0.0',
        search: 'v1.3.0',
        ecommerce: 'v1.0.0',
        end_of_call_survey: 'v1.0.0',
        focus: 'v1.0.0',
        ipseity: 'v1.0.0',
        load: 'v1.1.0',
        new_call: 'v1.0.0',
        test: 'v1.0.0',
        view: 'v1.0.0'
      }
    })
    window.universalJavascriptLoaded = true
    if (props.userLogin) props.userLogin()
    this.setupSplitTests()
  }

  setupSplitTests () {
    if (!this.props.initialiseSplitTest) return
    this.props.initialiseSplitTest({
      name: 'flight_dropdown_alternative_options',
      percentage: 50
    })
  }

  getHomePageBanner () {
    const { formSettings: { imageCloudCDN, imageCloudWebsite } } = this.props
    const imgUrlBase = `${imageCloudCDN}/${imageCloudWebsite}`
    const homepageImages = `${imgUrlBase}/pages/homepage`
    const imgUrl = {
      left: `${homepageImages}/homepage-review-left/recent.jpg`,
      right: `${homepageImages}/homepage-review-right/recent.jpg`
    }
    return {
      review: "In April we're all about helping you navigating the ongoing Brexit debacle. Follow our simple advice and you'll be able to confidently book your holiday no matter what's going on in Westminster and Brussels. Other things we'll be helping you navigate this month are mobile travel apps; picking the best Easter break; and the ever-popular Canary island of Tenerife.",
      reviewer: 'The HX Team',
      reviewDate: 'April 2019',
      imageLeft: imgUrl.left,
      imageRight: imgUrl.right
    }
  }

  render () {
    const { relatedPages, agentData, agents: agentSettings, loggedInData, domainSettings, formSettings, settings, pageData, dataSource, appSettings, splitTestData = { }, updateAgent } = this.props
    const flightDropdownAlternativeOptions = this.props.splitTestIsActive('flight_dropdown_alternative_options', splitTestData)
    const reviewData = this.getHomePageBanner()
    const containerClass = classNames({
      'homepageContainer': true,
      'loungeFlightSplitTest': true,
      'vehicleFound': true
    })
    const showPromoModal = Helpers.getParameterByName('promo')

    return (
      <div className={containerClass}>
        <Nav
          hideLinksMobile
          showSearchForm
          tradeMark
          showBookingsButton
          showAppLink
          includeAlerts
          isHomepage
          domainSettings={domainSettings}
          pageData={pageData}
          settings={settings}
          appSettings={appSettings}
          showStrapLineText={'Less hassle. More holiday.'}
          showWelcomeBackMsg
        />
        <div className='jumbotron jumbotron-cover'>
          <div className='container'>
            <Engine productList={['cp', 'hcp', 'ho', 'lo', 'otherProducts', 'fasttrack', 'transfers', 'carhire', 'ins', 'medical', 'porthotelsparkinglink']} terminalsInLocations={false} userData={loggedInData} agentData={agentData} isHomepage domainSettings={domainSettings} formSettings={formSettings} settings={settings} agentSettings={agentSettings} longerDateLabels={false} showBookingFeesMessage={false} showFlight loungeFlight terminalLink showTerminalsField flightSecondChanceModal hotelParkingFlight showOtherProductsOnMobile engineImage fastTrackFlight flightDropdownAlternativeOptions={flightDropdownAlternativeOptions} />
          </div>
          <HomePageBanner reviewData={reviewData} />
          <Editorial domainSettings={domainSettings} relatedPages={relatedPages} />
        </div>
        <FooterLogic domainSettings={domainSettings} formSettings={formSettings} dataSource={dataSource} />
        {showPromoModal && (
          <PromoModal updateAgent={updateAgent} />
        )}
      </div>
    )
  }
}

Homepage.propTypes = {
  agents: object,
  dataSource: object,
  domainSettings: object,
  formSettings: object,
  locations: object,
  pageData: object.isRequired,
  RoomTypes: object,
  settings: object,
  sortOptions: object
}
Homepage.defaultProps = {
  splitTestIsActive: () => {}
}

export default ReduxStores(Homepage, ['agents', 'login', 'splitTests'])
